import { render, staticRenderFns } from "./CalendarsList.vue?vue&type=template&id=5876ddf0&scoped=true"
import script from "./CalendarsList.vue?vue&type=script&lang=js"
export * from "./CalendarsList.vue?vue&type=script&lang=js"
import style0 from "./CalendarsList.vue?vue&type=style&index=0&id=5876ddf0&prod&lang=scss&scoped=true"
import style1 from "./CalendarsList.vue?vue&type=style&index=1&id=5876ddf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876ddf0",
  null
  
)

export default component.exports